var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "change") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(3.500000, 1.500000)",
    strokeWidth: 2.70000011
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FE815F",
    points: "8.98753282 -2.55795395e-14 16.2000006 7.18753274 7.67386185e-14 7.18753274"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#C4CBDD",
    transform: "translate(8.100000, 17.081299) rotate(180.000000) translate(-8.100000, -17.081299) ",
    points: "8.98753282 13.487533 16.2000006 20.6750657 7.67386185e-14 20.6750657"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.51f3139fd745036b86b16b2a3e0cc9eb.svg";
export { ForwardRef as ReactComponent };